/**
 * Collection banner sync for Shop By Color + Our Scrubs Collection categories.
 * Only applies overrides when URL params are present — never reuses sessionStorage
 * so each collection keeps its own Liquid banner title/colour/image.
 */
(function () {
  const COLOR_MAP = {
    'fresh-green': { hex: '#3FAE6E', name: 'Fresh Green', eyebrow: 'Shop by colour' },
    army: { hex: '#4B5C3A', name: 'Army Green', eyebrow: 'Shop by colour' },
    'army-green': { hex: '#4B5C3A', name: 'Army Green', eyebrow: 'Shop by colour' },
    black: { hex: '#1A1A1A', name: 'Black', eyebrow: 'Shop by colour' },
    toffee: { hex: '#8B5A3C', name: 'Toffee Brown', eyebrow: 'Shop by colour' },
    'toffee-brown': { hex: '#8B5A3C', name: 'Toffee Brown', eyebrow: 'Shop by colour' },
    graphite: { hex: '#5B5F66', name: 'Graphite Grey', eyebrow: 'Shop by colour' },
    'graphite-grey': { hex: '#5B5F66', name: 'Graphite Grey', eyebrow: 'Shop by colour' },
    fuschia: { hex: '#C73B8A', name: 'Fuchsia Pink', eyebrow: 'Shop by colour' },
    fuchsia: { hex: '#C73B8A', name: 'Fuchsia Pink', eyebrow: 'Shop by colour' },
    'fuschia-pink': { hex: '#C73B8A', name: 'Fuchsia Pink', eyebrow: 'Shop by colour' },
    'fuchsia-pink': { hex: '#C73B8A', name: 'Fuchsia Pink', eyebrow: 'Shop by colour' },
    'hot-pink': { hex: '#E83E8C', name: 'Hot Pink', eyebrow: 'Shop by colour' },
    rose: { hex: '#E8A0B0', name: 'Rose', eyebrow: 'Shop by colour' },
    'rose-pink': { hex: '#E8A0B0', name: 'Rose Pink', eyebrow: 'Shop by colour' },
    lilac: { hex: '#B9A7D0', name: 'Lilac', eyebrow: 'Shop by colour' },
    maroon: { hex: '#7A1F3D', name: 'Maroon', eyebrow: 'Shop by colour' },
    mustard: { hex: '#C7A441', name: 'Mustard', eyebrow: 'Shop by colour' },
    navy: { hex: '#1E3A5F', name: 'Navy', eyebrow: 'Shop by colour' },
    'navy-blue': { hex: '#1E3A5F', name: 'Navy Blue', eyebrow: 'Shop by colour' },
    royal: { hex: '#2F5DB0', name: 'Royal Blue', eyebrow: 'Shop by colour' },
    'royal-blue': { hex: '#2F5DB0', name: 'Royal Blue', eyebrow: 'Shop by colour' },
    teal: { hex: '#2A7F8C', name: 'Teal', eyebrow: 'Shop by colour' },
    'teal-blue': { hex: '#2A7F8C', name: 'Teal Blue', eyebrow: 'Shop by colour' },
  };

  const CATEGORY_MAP = {
    'jogger-edition': {
      hex: '#2F4A3A',
      hexEnd: '#6E8B74',
      name: 'Jogger Edition',
      eyebrow: 'Our Scrubs Collection',
      match: (t) => t.includes('jogger') && !t.includes('straight leg'),
    },
    'straight-leg-edition': {
      hex: '#1E3A5F',
      hexEnd: '#6B8CAE',
      name: 'Straight Leg Edition',
      eyebrow: 'Our Scrubs Collection',
      match: (t) => t.includes('straight leg'),
    },
    'fun-scrubs': {
      hex: '#8B2E5F',
      hexEnd: '#E89AB8',
      name: 'Fun Scrubs',
      eyebrow: 'Our Scrubs Collection',
      match: (t) => t.includes('pug') || t.includes('coffee') || t.includes('printed'),
    },
    sets: {
      hex: '#3D2B1F',
      hexEnd: '#A67C52',
      name: 'Sets',
      eyebrow: 'Our Scrubs Collection',
      match: (t) => /\bset\b/.test(t) || t.includes(' scrub set'),
    },
    tops: {
      hex: '#4A3F6B',
      hexEnd: '#9B8EC4',
      name: 'Tops',
      eyebrow: 'Our Scrubs Collection',
      match: (t) => t.includes(' top') || t.includes('top-'),
    },
    bottoms: {
      hex: '#1A1A1A',
      hexEnd: '#666666',
      name: 'Bottoms',
      eyebrow: 'Our Scrubs Collection',
      match: (t) => t.includes('pants') || t.includes(' jogger'),
    },
  };

  function getContrast(hex) {
    const c = hex.replace('#', '');
    const r = parseInt(c.slice(0, 2), 16);
    const g = parseInt(c.slice(2, 4), 16);
    const b = parseInt(c.slice(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 150 ? '#111111' : '#ffffff';
  }

  function clearStoredFilters() {
    try {
      sessionStorage.removeItem('sap_color');
      sessionStorage.removeItem('sap_category');
    } catch (e) {
      /* ignore */
    }
  }

  function restoreDefaultBanner() {
    const banner = document.getElementById('sap-collection-banner');
    if (!banner) return;

    const defaultBg = banner.dataset.defaultBg;
    const defaultTitle = banner.dataset.defaultTitle;

    if (defaultBg) {
      banner.style.setProperty('--sap-banner-bg', defaultBg);
      banner.style.background = defaultBg;
      const chip = banner.querySelector('.sap-coll-banner__chip');
      if (chip) chip.style.background = defaultBg;
      banner.style.setProperty('--sap-banner-text', getContrast(defaultBg));
    }

    if (defaultTitle) {
      const title = banner.querySelector('.sap-coll-banner__title');
      if (title) title.textContent = defaultTitle;
    }

    const eyebrow = banner.querySelector('.sap-coll-banner__eyebrow');
    if (eyebrow && banner.dataset.defaultEyebrow) {
      eyebrow.textContent = banner.dataset.defaultEyebrow;
    }
  }

  function readParams() {
    const params = new URLSearchParams(window.location.search);
    const category = params.get('sap_category');
    const color = params.get('sap_color');
    const hex = params.get('sap_hex');
    const hexEnd = params.get('sap_hex_end');
    const name = params.get('sap_name');

    if (category) {
      const mapped = CATEGORY_MAP[category];
      return {
        type: 'category',
        slug: category,
        hex: hex ? (hex.startsWith('#') ? hex : `#${hex}`) : mapped?.hex,
        hexEnd: hexEnd ? (hexEnd.startsWith('#') ? hexEnd : `#${hexEnd}`) : mapped?.hexEnd,
        name: name || mapped?.name,
        eyebrow: mapped?.eyebrow || 'Our Scrubs Collection',
        match: mapped?.match,
      };
    }

    if (color || hex) {
      const mapped = color ? COLOR_MAP[color] : null;
      return {
        type: 'color',
        slug: color || '',
        hex: hex ? (hex.startsWith('#') ? hex : `#${hex}`) : mapped?.hex,
        name: name || mapped?.name,
        eyebrow: mapped?.eyebrow || 'Shop by colour',
      };
    }

    return null;
  }

  function applyBanner(data) {
    const banner = document.getElementById('sap-collection-banner');
    if (!banner || !data?.hex) return;

    const bg =
      data.hexEnd && data.type === 'category'
        ? `linear-gradient(135deg, ${data.hex} 0%, ${data.hexEnd} 100%)`
        : data.hex;

    banner.style.setProperty('--sap-banner-bg', data.hex);
    banner.style.background = bg;

    const chip = banner.querySelector('.sap-coll-banner__chip');
    if (chip) chip.style.background = data.hexEnd ? `linear-gradient(135deg, ${data.hex}, ${data.hexEnd})` : data.hex;

    const textColor = getContrast(data.hex);
    banner.style.setProperty('--sap-banner-text', textColor);

    const title = banner.querySelector('.sap-coll-banner__title');
    if (title && data.name) title.textContent = data.name;

    const eyebrow = banner.querySelector('.sap-coll-banner__eyebrow');
    if (eyebrow && data.eyebrow) eyebrow.textContent = data.eyebrow;
  }

  function filterProducts(data) {
    if (data?.type !== 'category' || typeof data.match !== 'function') return;

    const items = document.querySelectorAll('#product-grid .grid__item[data-product-title]');
    if (!items.length) return;

    let visible = 0;
    items.forEach((item) => {
      const title = (item.dataset.productTitle || '').toLowerCase();
      const show = data.match(title);
      item.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });

    const countEl = document.querySelector('.sap-coll-banner__count, [class*="__count"]');
    if (countEl) {
      countEl.textContent = `${visible} ${visible === 1 ? 'product' : 'products'}`;
    }

    const grid = document.getElementById('product-grid');
    if (grid && visible === 0) {
      grid.classList.add('sap-category-empty');
    } else if (grid) {
      grid.classList.remove('sap-category-empty');
    }
  }

  function bindLinks() {
    document.querySelectorAll('[data-sap-color], [data-sap-category]').forEach((link) => {
      link.addEventListener('click', () => {
        const rawCategory = link.dataset.sapCategory;
        const isClear = rawCategory === '';
        if (isClear) {
          clearStoredFilters();
          return;
        }

        const isCategory = rawCategory !== undefined && rawCategory !== '';
        // Storage is only a click hint for the next URL with params — never a page-load source.
        try {
          if (isCategory) {
            sessionStorage.setItem(
              'sap_category',
              JSON.stringify({
                type: 'category',
                slug: link.dataset.sapCategory,
                hex: link.dataset.sapColorHex,
                hexEnd: link.dataset.sapColorEnd,
                name: link.dataset.sapColorName,
              })
            );
            sessionStorage.removeItem('sap_color');
          } else if (link.dataset.sapColor) {
            sessionStorage.setItem(
              'sap_color',
              JSON.stringify({
                type: 'color',
                slug: link.dataset.sapColor,
                hex: link.dataset.sapColorHex,
                name: link.dataset.sapColorName,
              })
            );
            sessionStorage.removeItem('sap_category');
          }
        } catch (e) {
          /* ignore */
        }
      });
    });
  }

  function init() {
    const fromUrl = readParams();
    bindLinks();

    if (fromUrl?.hex) {
      if (fromUrl.type === 'category' && !fromUrl.match && CATEGORY_MAP[fromUrl.slug]) {
        fromUrl.match = CATEGORY_MAP[fromUrl.slug].match;
        fromUrl.hexEnd = fromUrl.hexEnd || CATEGORY_MAP[fromUrl.slug].hexEnd;
        fromUrl.eyebrow = fromUrl.eyebrow || CATEGORY_MAP[fromUrl.slug].eyebrow;
      }
      applyBanner(fromUrl);
      filterProducts(fromUrl);
      return;
    }

    // Plain collection visit: keep Liquid banner, clear sticky filters
    clearStoredFilters();
    restoreDefaultBanner();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
